module.exports = __webpack_public_path__ + "static/buckler-1c18520a09ccde1cd4d1fcb343ab857b.jpg";